var exports = {
  "K6": "aboutHeading__oUkuib",
  "r9": "editButton__g5XcNs",
  "QN": "noDescription__YdD1TI",
  "h_": "description__ej4leF",
  "m5": "websiteRow__c4vvco",
  "UC": "websiteLink__zpxpsL",
  "c5": "socialStat__OaJfGy",
  "mQ": "insights__9SON7y",
  "m": "insightLinks__Vv5-fu",
  "_T": "insightStats__Z3jICr",
  "qw": "insightItem__0CLkke",
  "nc": "licensesTrigger__fTrdA_",
  "uM": "licensesCaret__a59-2M",
  "JY": "licensesDialogTitle__g0uiaM",
  "XJ": "licensesList__JdAjn2",
  "gc": "licensesItem__1pV092",
  "i2": "licensesFilepath__Hyqj2g",
};

module.exports = exports;
